// extracted by css-extract-rspack-plugin
export default {"clearAllFilters":"jufxMdnVIgwVKcsm","srOnly":"XluwJG_BpeQfgnMp","severityBadge":"XzuA5dP8ojcpf7YQ","infoIcon":"FNcUt5MoY6knY8Rz","stale":"R44OpxH308UcUdXs"};